<template>
    <component
        v-for="(item, index) in items"
        :is="item?.tag"
        :key="index"
        :class="item?.class"
    >
        <template v-if="item?.class == 'word'">{{ item?.content }}</template>
        <v-nested-elements v-else-if="item?.length || item?.children?.length" :items="item?.length ? item : item?.children"/>
    </component>
</template>

<script>

export default {
    name: 'v-nested-elements',
    props: {
        items: {
            type: [Array, Object],
            required: true
        },
    },
}

</script>
